/*
  报表管理--设备指标报表--设备完好率-电站完好率趋势
 */
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Modal, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import StubStatusLog from "@/pages/configurationManagement/stub/stubStatusLog";
import { getStubRate } from "../../../fetch/fetchApi";
import StubStationIntactDetail from "./stubStationIntactDetail";
import fetchHandler from "../../../fetch/fetchHandler";
import "@/assets/stylus/data_analysis.styl";

class StubStationIntact extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableConfig: this.initTable(), // 初始化表格
      tableDate: [], // 初始化表格数据
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  /**
   *  父组件条件修改子组件进行更新
   */
  componentWillMount() {
    this.query = {};
    //  let time =  moment(new Date()).subtract(1, 'd').format('YYYY-MM-DD')

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubGroupName"] = window.LayoutTab.tabParam.stubName;
      this.query["stubGroupId"] = window.LayoutTab.tabParam.stubGroupId;
      this.query["time"] = moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"); // 设置默认日期，为当月1日
      this.query["sortType"] = "2"; // 排序关键词：2：完好率，1：离线率，0：故障率
      this.query["sortWay"] = "1"; // 排序方式：1：由低到高，-1：由高到低
    }
    this.initTable();
    // this.setState(
    //   {
    //     currentState: this.query.stubGroupName, // 当前选择电站名称
    //     stubGroupId: this.query.stubGroupId, // 当前选择电站id
    //     time: this.query.time, // 当前选择日期数据
    //     sortType: this.query.sortType, // 排序关键词
    //     sortWay: this.query.sortWay, // 排序方式

    //     seeDetailVisible: false, // 状态日志弹窗展示标识
    //     stubIdData: "", // 设备ID初始化
    //   },
    //   () => {
    //     // 通过接口获取数据
    //     this.queryStubOperationModeInfo();
    //   },
    // );
  }

  // 调用接口获取数据
  queryStubOperationModeInfo() {
    fetchHandler(getStubRate, {
      page: 1,
      pagecount: 10,
      stubGroupId: window.LayoutTab.tabParam.stubGroupId,
      time: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
      curDay: 2,
      sortType: "2",
      sortWay: "1",
      // page:1,
      // pagecount:10,
      // stubGroupId: this.state.stubGroupId,
      // time: this.state.time,
      // curDay: 2,
      // sortType: this.state.sortType,
      // sortWay: this.state.sortWay,
    }).then((res) => {
      if (res) {
        this.setState(
          {
            tableDate: res.data ? res.data : [], // 设置表格数据
          },
          () => {
            this.setState({
              tableConfig: this.initTable(), // 重置表格
            });
          },
        );
      }
    });
  }

  // 获取选取的日期
  changeDay = (value) => {
    this.setState(
      {
        time: value, // 设置选取日期
      },
      () => {
        this.queryStubOperationModeInfo(); // 获取数据
      },
    );
  };

  /**
   * 初始化表格
   */
  initTable() {
    const tableConfig = {
      tableKey: "stubStationListTable",
      tableColumns: [
        {
          name: "排名",
          key: "serial",
          colType: "textCol",
          align: "center",
          // render:(value,row,index)=>{
          //     return index+1
          // }
        },
        {
          name: "设备编号",
          key: "stubId",
          colType: "textCol",
          align: "left",
        },
        {
          name: "设备类型",
          key: "type",
          colType: "textCol",
          align: "left",
          render: (value) => {
            switch (value) {
              case 0:
                return "交流电";
              case 1:
                return "直流电";
              case 2:
                return "交直流";
              default:
                return "未知";
            }
          },
        },
        {
          name: "可用时长",
          message: (
            <div className="mcjs">
              <p>
                <b>可用时长：</b>运营时长 + 维护时长；
              </p>
            </div>
          ),
          key: "totalAvailableDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return value !== "--" ? this.handleSecord(value) : "--";
          },
        },
        {
          name: "运营时长",
          message: (
            <div className="mcjs">
              <p>
                <b>运营时长：</b>空闲时长（包含插枪空闲时长） + 充电中时长 + 车位占用时长 + 故障时长
                + 离线时长 + 升级中时长 + 预约等待充电中时长 + 储能中时长 + 在线预约中时长 +
                充满时长；
              </p>
            </div>
          ),
          key: "totalOperationDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return this.handleSecord(value);
          },
        },
        {
          name: "可用率",
          message: (
            <div className="mcjs">
              <p>
                <b>可用率</b>=（可用时长 - 维护时长）/可用时长
              </p>
            </div>
          ),
          key: "availableRate",
          colType: "textCol",
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "故障时长",
          message: (
            <div className="mcjs">
              <p>
                <b>故障时长：</b>
                设备变更为故障状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
            </div>
          ),
          key: "totalErrorDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return this.handleSecord(value);
          },
        },
        {
          name: "故障率",
          message: (
            <div className="mcjs">
              <p>
                <b>故障率</b>=故障时长/运营时长
              </p>
            </div>
          ),
          key: "errorRate",
          colType: "textCol",
          sorter: true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "离线时长",
          key: "totalOfflineDuration",
          colType: "textCol",
          align: "left",
          message: (
            <div className="mcjs">
              <p>
                <b>离线时长：</b>
                设备变更为离线状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
            </div>
          ),
          render: (value) => {
            return this.handleSecord(value);
          },
        },
        {
          name: "离线率",
          key: "offlineRate",
          colType: "textCol",
          sorter: true,
          align: "center",
          message: (
            <div className="mcjs">
              <p>
                <b>离线率</b>=离线时长/运营时长
              </p>
            </div>
          ),
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "完好时长",
          key: "totalOperationDuration",
          colType: "textCol",
          align: "left",
          message: (
            <div className="mcjs">
              <p>
                <b>完好时长</b>=运营时长 - 故障时长 -离线时长。
              </p>
            </div>
          ),
          render: (value, row) => {
            if (
              row.totalOperationDuration !== "--"
              && row.totalErrorDuration !== "--"
              && row.totalOfflineDuration !== "--"
            ) {
              const info = row.totalOperationDuration
                - row.totalErrorDuration - row.totalOfflineDuration;
              return this.handleSecord(info);
            } else {
              return "--";
            }
          },
        },
        {
          name: "完好率",
          key: "intactRate",
          colType: "textCol",
          sorter: true,
          align: "center",
          message: (
            <div className="mcjs">
              <p>
                <b>完好率</b>=(运营时长-离线时长-故障时长)/运营时长
              </p>
            </div>
          ),
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "状态日志",
          key: "action",
          fix: "right",
          width: 100,
          colType: "action",
          actionMap: [
            {
              type: "href",
              actionName: "查看",
              handler: (record) => {
                this.setState(
                  {
                    stubIdData: record.stubId,
                  },
                  () => {
                    this.modalVisibleAction("seeDetailVisible", true);
                  },
                );
              },
            },
          ],
        },
      ],
      tableChange: (pagination, filters, sorter) => {
        // 点击表格头部排序执行
        /**
         * sortType:排序关键词
         * sortWay:排序方式
         */
        let sortType = '';
        if (sorter.columnKey === "intactRate") {
          sortType = '2';
        } else if (sorter.columnKey === "offlineRate") {
          sortType = '1';
        } else {
          sortType = '0';
        }
        let sortWay = '';
        if (sorter.order === "ascend") {
          sortWay = '1';
        } else if (sorter.order === "descend") {
          sortWay = '-1';
        } else {
          sortWay = '1';
        }
        this.setState(
          {
            sortType: sortType,
            sortWay: sortWay,
          },
          () => {
            this.queryStubOperationModeInfo(); // 设置排序方式后，获取数据
          },
        );
      },
      tableParam: {
        pagecount: 10,
        stubGroupId: window.LayoutTab.tabParam.stubGroupId,
        time: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
        curDay: 2,
        sortType: "2",
        sortWay: "1",
      },
      dataApi: getStubRate,
      autoRefresh: true, // 设置为true 直接加载grid数据
    };

    return tableConfig;
  }

  // 秒转换
  handleSecord(value) {
    if (value === "--") {
      return "--";
    }
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  // 模态框展示方法
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  render() {
    const val = (
      <div className="analysis-content-3">
        <div style={{ padding: "20px" }}>
          <StubStationIntactDetail
            stubGroupId={this.state.stubGroupId}
            changeDay={this.changeDay}
          />
        </div>
        <div className="titleChart" style={{ fontSize: "14px" }}>
          电站-{this.state.currentState}近7天完好率情况
        </div>
        <div style={{ padding: "0 20px" }} className="tableTitle">
          {this.state.time}设备完好率详情{" "}
          <Tooltip title="上方折线图可点击选择日期，展示对应日期该电站的设备完好率详情">
            {" "}
            <QuestionCircleOutlined style={{ margin: "0 10px", color: "#999" }} />
          </Tooltip>
        </div>
        <div>
          <ScGridTable config={this.state.tableConfig} />
        </div>

        {/* 状态日志弹窗 */}

        <Modal
          title="状态日志"
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeDetailVisible", false);
          }}>
          <StubStatusLog stubIdData={this.state.stubIdData} />
        </Modal>
      </div>
    );

    return val;
  }
}

export default StubStationIntact;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubStationIntact.js